import { companyConfig } from "./companyConfig";

export const footerLinks = {
  navigation: [
    { label: "Inicio", href: "/" },
    { label: "Empresa", href: "/nosotros" },
    { label: "Soluciones", href: "/servicios" },
    { label: "Novedades", href: "/noticias" },
    { label: "Hablemos", href: "/contacto" },
    { label: "Política de Protección de Datos", href: "/politica-proteccion-datos" },
  ],
  external: [
    { label: "Soporte 24/7", href: companyConfig.serviceDeskUrl },
  ],
};
